<template>
    <span>
        <span class="field">
        <span :class="getIcon() ? 'control has-icons-left' : 'control'">
            <input 
                :style="style" 
                :class="'input is-rounded ' + themeAjust" type="text" 
                :placeholder="placeholder"
                :disabled  = "disabled"
                :maxlength="maxlengthComputed"
                v-on:blur="$emit('blur')"
                :value="inputVal"
                @input="e => inputVal = e.target.value"
                :ref="id"
            >
            <span class="icon is-small is-left" v-show="getIcon()">
            <i :class="'fas fa-' + icon"></i>
            </span>
        </span>
        </span>
    </span>
</template>
<style scoped>
    ::placeholder {
        color: rgb(165, 162, 162);
        font-size:15px;
    }
    input {
        color: black;
        font-weight: bolder;
        font-size:17px;
    }
    input:disabled {
        background-color: rgb(231, 229, 229);
    }
</style>
<script>
export default {
    props: ["id","theme", "placeholder", "value", "mandatory", "width", "disabled", "icon", "maxlength"],
    watch: {
        inputVal: function(val) {
            this.$emit("change");
        }
    },
    

    computed: {
        maxlengthComputed: {
            get() {
                
                if (typeof(this.maxlength)=="undefined")
                    return 50;
                else    
                    return this.maxlength;
            }
        },
        inputVal: {
        get() {
            return this.value;
        },
        set(val) {
            this.$emit('input', val);
        }
        },
        themeAjust: {
            get() {
                if (this.mandatory)
                    return this.theme + " is-danger";
                else    
                    return this.theme;
            }
        },
        style: {            
            get() {
                if (typeof(this.width) != "undefined") {                    
                    return 'width:' + this.width;
                }
            }
        }
    },
    methods: {
        focusInput() {
          
            this.$nextTick(()=> {
                this.$refs[this.id].focus();
            })
        },
        getIcon() {
                if (typeof(this.icon) != "undefined") {
                    return true;
                }
                else    
                    return false;
            }
    }
  
}
</script>